import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_164_193)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M17.94 17.9688C16.2306 19.2165 14.1491 19.9077 12 19.9414C5 19.9414 1 12.2809 1 12.2809C2.24389 10.0612 3.96914 8.1219 6.06 6.59307M9.9 4.85032C10.5883 4.69604 11.2931 4.61892 12 4.62051C19 4.62051 23 12.2809 23 12.2809C22.393 13.3683 21.6691 14.3921 20.84 15.3355M14.12 14.3109C13.8454 14.5932 13.5141 14.8196 13.1462 14.9766C12.7782 15.1336 12.3809 15.218 11.9781 15.2248C11.5753 15.2316 11.1752 15.1607 10.8016 15.0162C10.4281 14.8717 10.0887 14.6566 9.80385 14.3839C9.51897 14.1111 9.29439 13.7862 9.14351 13.4285C8.99262 13.0708 8.91853 12.6876 8.92563 12.3019C8.93274 11.9162 9.02091 11.5358 9.18488 11.1834C9.34884 10.8311 9.58525 10.5139 9.88 10.2509",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1 1.7478L23 22.814",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_164_193",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 22.9813,
			fill: "white",
			transform: "translate(0 0.790283)"
		})
	}) })]
});
export default SvgEyeClose;
